import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
});

// Attach bearer if we saved token in localStorage (fallback for cross-site cookie edge cases)
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ssk_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export default api;
